import IconButton from "@mui/material/IconButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Stack from "@mui/material/Stack";
import TransactionHeader from "@app.automotus.io/components/TransactionHeader";
import TransactionDetail from "@app.automotus.io/components/TransactionDetail";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useSearchParams } from "react-router-dom";
import React, { useEffect } from "react";
import { PayeeTableDisplayMode } from "@app.automotus.io/components/PayeeTables/PayeeTableToolbar";
import { CurbPassTransactionsTable } from "@app.automotus.io/components/PayeeTables/CurbPassTransactionsTable";

export const Dashboard: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [transactionId, setTransactionId] = React.useState<string>("");

  const tab = searchParams.get("tab") || "digital_wallet_transactions";

  useEffect(() => {
    if (searchParams?.get("transactionId")) {
      setTransactionId(searchParams?.get("transactionId") as string);
    }
  }, [searchParams]);
  const tableDisplayMode: PayeeTableDisplayMode = (searchParams.get("displayMode") as PayeeTableDisplayMode) || "month";
  const setTableDisplayMode = (newDisplayMode: PayeeTableDisplayMode) => {
    searchParams.set("displayMode", newDisplayMode);
    setSearchParams(searchParams, { replace: true });
  };

  const selectTransactionId = (id: string) => {
    searchParams.set("transactionId", id);
    setSearchParams(searchParams, { replace: true });
    setTransactionId(id);
  };

  const handleClickBack = () => {
    if (transactionId) {
      searchParams.delete("transactionId");
      setSearchParams(searchParams);
      setTransactionId("");
      return;
    }

    if (tableDisplayMode === "day") {
      setTableDisplayMode("month");
      return;
    }
  };

  return (
    <>
      <IconButton
        onClick={handleClickBack}
        sx={{ visibility: Boolean(transactionId) || tableDisplayMode === "day" ? "visible" : "hidden" }}
      >
        <ArrowBackIosIcon />
      </IconButton>
      <Stack spacing={3} width="100%">
        <ContentTitle displayMode={transactionId ? "transaction" : tableDisplayMode} />
        {transactionId ? (
          <Stack spacing={3}>
            <TransactionHeader transactionId={transactionId} />
            <TransactionDetail transactionId={transactionId} />
          </Stack>
        ) : (
          <Paper sx={{ width: "100%" }}>
            <CurbPassTransactionsTable
              variant={tab === "park_transactions" ? "park" : "wallet"}
              onClickTransaction={selectTransactionId}
            />
          </Paper>
        )}
      </Stack>
    </>
  );
};

const ContentTitle: React.FC<ContentTitleProps> = ({ displayMode }) => {
  const title =
    displayMode === "month" ? "Monthly Transactions" : displayMode === "day" ? "Dated Transactions" : "Park Event";
  const description =
    displayMode === "month"
      ? "Recent transactions can take up to 24 hours to process"
      : displayMode === "day"
      ? "Transactions processed for the selected date"
      : "A detailed description of a park event";

  return (
    <Box>
      <Typography variant={"h4"} fontWeight={600}>
        {title}
      </Typography>
      <Typography variant={"subtitle1"} color={"text.disabled"} fontSize={"0.75rem"}>
        {description}
      </Typography>
    </Box>
  );
};

interface ContentTitleProps {
  displayMode: "month" | "day" | "transaction";
}
